const Env = () => {
    return {
        API_URL: 'https://concours.eaa.sn/api/v1',
        // ANNEE_UNIVERSITE : '2025-2026',
    };
}
export default Env;
